import { render, staticRenderFns } from "./user-management.vue?vue&type=template&id=20853d7e&scoped=true&"
import script from "./user-management.vue?vue&type=script&lang=js&"
export * from "./user-management.vue?vue&type=script&lang=js&"
import style0 from "./user-management.vue?vue&type=style&index=0&id=20853d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20853d7e",
  null
  
)

export default component.exports